import { openReviewer } from '@/api/open'
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      detail: {},
      code: '',
      form: {
        turnstileToken: ''
      },
      captcha: {},
      rules: {},
      submitting: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      manuscriptType: 'getManuscriptType'
    })
  },
  mounted() {
    this.code = this.$route.query.reviewskey
    if (this.code) {
      this.getQuery(this.code)
      this.getCaptcha()
    }
    this.getRules()
  },
  methods: {
    async getQuery() {
      const data = await openReviewer.reviewsCode(this.code)
      this.detail = data
    },
    cancel() {
      this.$router.push('/access/login')
    },
    async getCaptcha() {
      const data = await openReviewer.confirmCheck(this.code, {
        w: 160,
        h: 40
      })
      if (data && data.codeImage && !data.codeImage.includes('data:image')) {
        data.codeImage = `data:image/png;base64,${data.codeImage}`
      }
      this.captcha = data || {}
    },
    getRules() {
      this.rules = {
        turnstileToken: [
          {
            required: true,
            message:
              'Verification Code' + this.LANGUAGE[this.language].noEmpty + '.'
          }
        ]
      }
    },
    async submit() {
      if (this.submitting) {
        return
      }
      const flag = this.$refs['review-confirm-form'].validate()
      if (!flag) {
        return
      }
      let data = {
        id: this.detail.id,
        status: 'AGREED',
        version: this.detail.version,
        turnstileToken: this.form.turnstileToken
      }
      try {
        this.submitting = true
        await openReviewer.confirmCode(this.code, data)
        this.$router.push(`/email-url/review-agree?reviewskey=${this.code}`)
      } catch (e) {
        this.form.turnstileToken = ''
        await this.getCaptcha()
      } finally {
        this.submitting = false
      }
    }
  }
}
